module.exports = __webpack_public_path__ + "img/speaker_11.4201b1ec.jpeg";